export default __webpack_public_path__ + "static/media/JS.1a6f34e2.svg";